<!-- Sidebar -->
<nav id="sidebar" [ngClass]="{'active': sidebarStatus === true}">
  <div class="sidebar-header animated bounce fadeIn">
    <div class="row">
      <div class="col-4 center line-height-100 pr0">
        <img *ngIf="!imageUser" [src]="logoCommunity" class="community-image br-circle" alt="comunidad">
        <img *ngIf="imageUser" [src]="imageUser" class="community-image br-circle" alt="comunidad">
      </div>
      <div class="col-8 text-left pt25">
        <label class="font-normal community-secondary">{{emailuser}}</label>
        <label class="font-normal community-secondary">{{ 'GENERAL.PROPERTIES' | translate }}: {{propertiesCount}}</label>
      </div>
    </div>
  </div>

  <!-- Sidebar Links -->
  <ul class="components m0 mt10 animated bounce fadeIn">
    <li>
      <a routerLinkActive="active" id="/properties" [routerLink]="['/properties']">
        <label *ngIf="'/properties' === urlActive">
          <i class="fal fa-home mr10 svg-width txt-secondary"></i>
        </label>
        <label *ngIf="'/properties' !== urlActive">
          <i class="fal fa-home mr10 svg-width"></i>
        </label>
        <span class="txt-item">{{'PROPERTIES.PLURAL' | translate}}</span>
      </a>
    </li>
  </ul>
</nav>



// WEBPACK FOOTER //
// ./src/app/layout/sidebar-property/sidebar-property.component.html